/* eslint-disable */
// src/forms/local/updatelocalForm.js

import React, { Component } from "react";
import localService from "../../services/localService";
import PropTypes from "prop-types";
import {
  Button,
  TextField,
  Grid,
  Container,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  Alert,
} from "@mui/material";
import data from "../../assets/departamentos-y-ciudades.json";
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";

class UpdateLocalForm extends Component {
  constructor(props) {
    super(props);
    const { local } = props;
    this.state = {
      local: local,
      // persons: [],
      selectedDepartamento: local ? local.Department : '',
      selectedCiudad: local ? local.City : '',
      generalError: "",
      showRequiredErrors: false,
      // selectedPerson: null,
      // isLoading: true,
    };
  }


  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      local: {
        ...prevState.local,
        [name]: value,
      },
      generalError: "",
    }));
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { local } = this.state;
    if (!local.Address?.trim() || !local.Department || !local.City) {
      this.setState({ showRequiredErrors: true, generalError: "" });
      return;
    }
    try {
      await localService.updateLocal(local.Id, local);
      if (typeof this.props.onSaved === "function") {
        await this.props.onSaved();
      }

      this.props.closeForm();
    } catch (error) {
      console.error("Hubo un error al actualizar el local:", error);
      this.setState({ generalError: `No se pudo actualizar el ${this.props.entityName || "local"}.` });
    }
  };

  handleDepartamentoChange = (event) => {
    const selectedDepartamento = event.target.value;
    this.setState(prevState => ({
      selectedDepartamento,
      selectedCiudad: '',
      generalError: "",
      local: {
        ...prevState.local,
        Department: selectedDepartamento,
        City: "",
      }
    }));
  };

  handleCiudadChange = (event) => {
    const selectedCiudad = event.target.value;
    this.setState(prevState => ({
      selectedCiudad,
      generalError: "",
      local: {
        ...prevState.local,
        City: selectedCiudad
      }
    }));
  };

  render() {
    return (
      <Container component={Paper} style={{ padding: "20px", marginTop: "20px" }}>
        <form onSubmit={this.handleSubmit} noValidate>
          <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={this.props.entityName === "tipo de baja" ? "Nombre del tipo de baja" : "Nombre"}
                        name="Name"
                        value={this.state.local.Name}
                        onChange={this.handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required error={this.state.showRequiredErrors && !this.state.selectedDepartamento}>
                    <InputLabel>Departamento</InputLabel>
                    <Select
                        value={this.state.selectedDepartamento}
                        onChange={this.handleDepartamentoChange}
                        label="Departamento"
                    >
                        {data.map((departamento) => (
                        <MenuItem key={departamento.id} value={departamento.name}>
                            {departamento.name}
                        </MenuItem>
                        ))}
                    </Select>
                    {this.state.showRequiredErrors && !this.state.selectedDepartamento && <FormHelperText>Seleccioná un departamento.</FormHelperText>}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={8}>
                    <TextField
                        fullWidth
                        label="Dirección"
                        required
                        name="Address"
                        value={this.state.local.Address}
                        onChange={this.handleChange}
                        error={this.state.showRequiredErrors && !this.state.local.Address?.trim()}
                        helperText={this.state.showRequiredErrors && !this.state.local.Address?.trim() ? "Ingresá una dirección." : ""}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl
                      fullWidth
                      required
                      disabled={!this.state.selectedDepartamento}
                      error={this.state.showRequiredErrors && !this.state.selectedCiudad}
                      sx={this.state.showRequiredErrors && !this.state.selectedCiudad && !this.state.selectedDepartamento ? {
                        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                          borderColor: "error.main",
                        },
                      } : undefined}
                    >
                    <InputLabel>Ciudad</InputLabel>
                    <Select
                        value={this.state.selectedCiudad}
                        onChange={this.handleCiudadChange}
                        label="Ciudad"
                    >
                        {data
                        .find((departamento) => departamento.name === this.state.selectedDepartamento)
                        ?.towns.map((ciudad) => (
                            <MenuItem key={ciudad.id} value={ciudad.name}>
                            {ciudad.name}
                            </MenuItem>
                        ))}
                    </Select>
                    {this.state.showRequiredErrors && !this.state.selectedCiudad && (
                      <FormHelperText>
                        {this.state.selectedDepartamento ? "Seleccioná una ciudad." : "Seleccioná primero un departamento para elegir la ciudad."}
                      </FormHelperText>
                    )}
                    </FormControl>
                </Grid>
                {this.state.generalError && (
                  <Grid item xs={12}>
                    <Alert severity="error">{this.state.generalError}</Alert>
                  </Grid>
                )}
            <Grid item xs={12} sx={{ mt: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <CancelButton onClick={this.props.closeForm} fullWidth>
                        Cancelar
                      </CancelButton>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <AcceptButton type="submit" fullWidth>
                        {`Actualizar ${this.props.entityName || "local"}`}
                      </AcceptButton>
                    </Grid>
                  </Grid>
                </Grid>
            </Grid>
        </form>
      </Container>
    );
  }
}

UpdateLocalForm.propTypes = {
  closeForm: PropTypes.func.isRequired,
  local: PropTypes.object.isRequired,
  entityName: PropTypes.string,
  onSaved: PropTypes.func,
};
export default UpdateLocalForm;
